import { useRef } from 'react';

export const useSmoothScroll = () => {
    const myRef = useRef(null);

    const clickHandle = (e) => {
        myRef.current?.scrollIntoView({
            behavior: "smooth",
            inline: 'center'
        });
    }

    return { myRef, clickHandle };
}